import { render, staticRenderFns } from "./BaseDraggableWindowSimple.vue?vue&type=template&id=23dab66e&scoped=true&"
import script from "./BaseDraggableWindowSimple.vue?vue&type=script&lang=js&"
export * from "./BaseDraggableWindowSimple.vue?vue&type=script&lang=js&"
import style0 from "./BaseDraggableWindowSimple.vue?vue&type=style&index=0&id=23dab66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dab66e",
  null
  
)

export default component.exports